import {isString} from './boolean';

export const redirect = url => {
  if (url && isString(url)) {
    // eslint-disable-next-line fp/no-mutation
    window.location.href = url;
    return true;
  }
  return false;
};

export const getHostNameFromURL = url => {
  try {
    const parsedURL = new URL(url);
    return parsedURL.hostname;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing URL:', error);
    return '';
  }
};
